<template>
  <div style="text-align: left;">
    <div
        style="padding:8px;background-color:#EEECED;width:100%;display:flex;align-items:center;justify-content:center;">
      <img :src="this.$store.getters.getBaseInfo.login_ico !==undefined ?this.$store.getters.getBaseInfo.login_ico:'/img/null.png'" alt="" style="width:30%;"></div>
    <div style="position:relative;"><img src="img/c1.png" alt="" style="width:100%;">
      <div style="color:#fff;font-size:1.5rem;position:absolute;bottom:60px;left:50%;transform:translateX(-50%);"> 양질의
        만남을⋯
      </div>
      <div style="color:#fff;font-size:1.2rem;position:absolute;bottom:22px;left:50%;transform:translateX(-50%);">
        ❤️ {{ this.$store.getters.getBaseInfo.name }} 클럽
      </div>
    </div>
    <div style="padding:1.1rem;line-height:2.2rem;"><p style="font-weight:bold;"> 혹시 이전 앱이나 친구클럽에서 만족스러운 커뮤니케이션을 하신 적이 있으신가요?</p>
      <p>브랜드와 돈에만 신경 쓰는 여성들에겐 질리지 않았나요?</p>
      <p> 진정으로 꿈을 좇는 여성들을 응원하고 싶지 않아요?</p>
      <p> 몸과 마음 모든 면에서 '아름다움'을 드러내는 여성을 만나본적이 있어요?</p>
      <p> ❤️ {{ this.$store.getters.getBaseInfo.name }} 만남 클럽은 남성이 직면한 고민을 해결하고 소원을 들어줄수 있어요</p></div>
    <div><img src="img/c2.png" alt="" style="width:100%;"></div>
    <div style="padding:1.1rem;line-height:2.2rem;"><p style="font-weight:bold;"> 아무리 미녀가 많아도 정말 소중히 여길 만한 좋은 여자는 손에 꼽을
      정도에요</p>
      <p> 훌륭한 남성들은 이 세상에 전혀 다른 급의 절세미인이 얼마나 많은지 이미 경험했어요 비록 님은 그들을 쫓아오고 소유했더라도 버킨백으로 얻은 것은 마음의 공허함일것이에요 </p>
      <p> 아무리 아름다운 여자라도 하루아침에 싫증이 나면 결코 '좋은 여자'가 아니에요 ❤️ {{ this.$store.getters.getBaseInfo.name }} 에서 정의한 '기준'을 직접 체험해보세요 </p>
      <p> 사랑받고 싶고 자랑하고 싶고 미녀와 자고 싶은... ...여자를 가지고 노는 남자는 다음에 무엇을 추구해야 할까요? </p>
      <p> '자꾸만 생각나는 여자'의 힘이 얼마나 놀라운지 아는 남자들에게 보내는 글이에요 만나서 느낌을 확인할 때까지는 소개비를 받지 않아요 어떤 여성을 만나고 싶은지 솔직하게 말해주세요 </p></div>
    <div><img src="img/c3.png" alt="" style="width:100%;"></div>
    <div style="padding:1.1rem;line-height:2.2rem;"><p style="font-weight:bold;">당신이 쌓아올린</p>
      <p>시간과 돈을 헛되이 하지 않겠습니다.</p>
      <p>저희 ❤️ {{ this.$store.getters.getBaseInfo.name }} 클럽 컨시어지가 가장 중요하게 생각하는 것이 무엇인지 아시나요?</p>
      <p>그건 간단합니다. 바로 "두 사람의 느낌(궁합)"입니다.</p>
      <p> 우리가 가장 중요하게 여기는 것은 그 궁합입니다. 그렇기 때문에 남성분께 먼저 여성과 만나보고 판단해 주시길 바랍니다. </p>
      <p> 만약 조금이라도 "뭔가 다르다…"고 느끼신다면, 솔직하게 거절하셔도 괜찮습니다. 거절하셔도 어떤 비용도 발생하지 않으니 안심하셔도 됩니다. </p>
      <p>많은 회원님들이 말씀하시는 것은 “시간을 낭비하는 것이 가장 큰 죄”라는 점입니다.</p>
      <p>저희는 한 분이라도 더 많은 만남을 제공해드리고자 합니다.</p>
      <p> 남성분의 취향이나 이상적인 여성에 가까운 만남을 위해서는, 이 소중한 시간을 어떻게 프로듀싱하느냐에 달려 있다고 생각합니다. </p>
      <p>저희는 절대로 시간과 돈을 낭비하는 만남은 제공하지 않습니다. 그것은 저희의 약속입니다.</p></div>
    <div style="padding:12px;"><h2 style="background-color:#e62978;text-align:center;line-height:2;"><strong><span
        style="font-size:20px;"><span style="color:#ffffff;"> 여성 회원 소개 </span></span></strong></h2></div>
    <div style="padding:1.1rem;line-height:2.2rem;"><p>수많은 여성 중에서 최고의 매칭을 실현해드립니다.</p>
      <p> 일정 기준의 외모나 교양 등의 면접을 통과한 여성들만 등록되어 있어, 다른 교제 클럽과는 차원이 다른 하이퀄리티 회원님들과의 데이트를 즐기실 수 있습니다. </p>
      <p>연예기획사 직영으로 모델이나 탤런트 등 외모와 품격을 겸비한 여성이 다수 소속되어 있습니다.</p>
      <p>평소에는 만날 수 없는 여성과의 특별한 데이트를 즐겨보세요.</p>
      <p>출장지에서도 전국 어디서든 이용이 가능합니다.</p></div>
    <div style="padding: 12px;">

      <swiper class="van-swipe"   :options="bannerSwiperOption">
        <swiper-slide v-for="(v,key) in list" :key="key">

          <div style="display: flex; padding: 8px 12px; border: 3px solid rgb(230, 41, 120); border-radius: 12px;">
            <img :src="v.url" alt="" style="width: 25%; border-radius: 12px;">
            <div style="flex: 1 1 0%; padding-left: 12px; display: flex; flex-direction: column; justify-content: space-between;">
              <div><span style="padding: 4px 8px; background-color: rgb(230, 41, 120); border-radius: 8px; color: rgb(255, 255, 255); font-size: 1.2rem; font-weight: bold;">{{ v.address }}</span>
              </div>
              <div> {{ v.title }}</div>
              <div style="color: rgb(136, 136, 136);">{{ v.content }}</div>
            </div>
          </div>
        </swiper-slide>
      </swiper>

    </div>
    <div style="background-color:#DBE6F1;padding:12px;">
      <div style="display:flex;column-gap:12px;">
        <img src="img/step1.png" alt=""
                                                      style="width:30%;object-fit:cover;border-radius:8px;"><img
          src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFAAAABQCAMAAAC5zwKfAAAAM1BMVEUAAAAhR3ohR3ohR3ohR3ohR3ohR3ohR3ohR3ohR3ohR3ohR3ohR3ohR3ohR3ohR3ohR3oOmH6fAAAAEHRSTlMAwIBAEKDQ8OAgYFCQcDCwETUB1AAAA2lJREFUWMOtmOvabiAQhs1MaY/zP9ol7XzKK1nzAxd1m2dmSpk6TBFpRDREbPpqi1vn7WzAtRqmGS62lkm7DNCUjbQ207GXOF46z4DoiAjRgsx3BbIRHCD9fcSMnV8jUUTXdLuHQhmFm67ERg/4r8gbCI3WZyddxD0VBwWkoId2PIilDik6REb/asOCXJy6jK1BzBNPxuB1O8l/84C9GZoyEtu83wJed1oHeInoGk9s5I0RTV2qkTdIFOp6V/jym4ZM+b7QCKAYnZCpDqMJcRg1W4n25WSncfNhXKdimAV/EU1/M6IvWSIiNSlDqovIY17KlCUbVbkRbskonkV8JPgfRcrfW84R1BcJYMjNi/dz3hyZvfsOJULuX8bdei0UfipjUzvITwGBcL0Dc8TxkDBVLrJSg+4KXNlvIBXglcICu8oapysQdyseynrszvlqrSY6yGkrQNjtAALyTVznYV8qKoVTtz6WYtM3kiWAq8opc2SlOHeE+xjWZmKeVWuaUaHFKyCLxWJaw1hKi1Ye04WvQ8+nIymrVMt6swiYg1RshVBLnxNzOLib9udoyu4Hezf8KJ2+W3bN18cooi5e3JX/P2DIRkryd2NhLIRjy1xYmVhWSg0BwNwSfwOXtFItgyzcwTEgk3soDBkPkcllnMeBfOex9BnXpXi7gHPDQeExZYgmgwpYJaUqm4xh5b3PwFI27cLGPXJFpegG4t3Qg+JWeWMNrIdeOn0HRteS8u/AnA3m0/wZmEH1J6AGXrLMa1apryRdN4CyXK7Vi2ornPozWnRGBdgDFF5pvlKNJaTJa4ylA6i9X8VXbDyGhIZWbFuadKlw2VrEcxXKlDqA6rxmlR5e5SxZeeQQ96YSEdsp4Wd9srm68cKXU9iTtRw8J0I2d1eMqPvfz5ocLC5+X7Sry7ZiHecxed3X0X/Y+LB6a7YM8nTcmtWbx7EwLnnzWImGoQCKdkrx0wac7n7Z8DGevp3CN/4ujuroZG9f9jYzS8+PG0HdPPf4a4lv3izrkxumD/dQ894k9bgnDj36oZkRBxKekFqG/3hLr5ANzI/Q7LgUnD4tQTiqdmp5akC9xWrLL2uj/sJ0om3CvalX3y11hBWDAWzZJLKXQ8rJ7d5AD01Ldm7TnJpGTWkL4sSSgIZNn22hYD2O/QOEGEqZt4auNAAAAABJRU5ErkJggg=="
          alt="" style="width:10%;height:10%;">
        <div style="flex:1;">
          <div style="line-height:1.5rem;font-size:1.2rem;font-weight:bold;color:#21477A;">세팅</div>
          <div style="font-size:.8rem;"> 저희 클럽은 고객님과 등록 여성 간의 연결인 "세팅"을 도와드립니다. 원하시는 등록 여성과의 세팅을 신청해 주세요.</div>
        </div>
      </div>
      <div style="display:flex;column-gap:12px;padding-top:12px;">
        <img src="img/step2.png" alt=""
                                                                       style="width:30%;object-fit:cover;border-radius:8px;"><img
          src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFAAAABQCAMAAAC5zwKfAAAAM1BMVEUAAAAhR3ohR3ohR3ohR3ohR3ohR3ohR3ohR3ohR3ohR3ohR3ohR3ohR3ohR3ohR3ohR3oOmH6fAAAAEHRSTlMAwIBAEPCgMGDQIOCQUHCwx+vuvgAAA3tJREFUWMOtWFmi2yAMNPsOuv9pmxiIGgscQzsfL882DGLQAhwPYYQ//guM5cxBBys8/QOxtFoBRYhpi05omELFZTttAIRjTHPGWAAEE3t07Fs0Y6NbpxS9T7HyoPD58/3RxGVs2nNkI5xttVR+4Ceu0tkfw/JKWeQv9c52Cq27sbKObG5b8Sq3f6Z1OAe/88o6aH7s+bW9vedTZsW/CCPhc3It1tWckSPfMuPIxxPyrTMqP3i/xTfv6XCcBeDc4khAsUo172zer/ixC/YOGXl9445teIX2oArm2Ee+rECYTVjKhUnrrwBS313TKYLMAKzCtN9y5PNXf0eHgBf8h54Y6CFEXiAJznkAzXUwAuD1wMLhC7ii0FEoh6EGRkjvCdemzSMAupe8exYAYqLqvalfFrR4QpgAaGS01Khw+n+pyhIhFC90wgyKZrLSjaU+yNW7EFwI3zgJtbDhmodl/dpmnAf7EAcgJlMGnACi9Dm7PmPaQs80nGXv2EwN4yIEbIXQN+kE+jiC6SQSA04WxWp5REKI8dYUybS8fHJcz0PQYMpbwbFEp+pxmAiNEGInLaYaMyQFbGduXgmP/wJRCckib8NXcevfETxnL0TRZc2xJrA8q2U/CCM0sJ51Psg7hAVARR7V5zsHKFbYk1esE+a2bTKq95c8y14/4jphAOAYorTfnDAM3cZ8MoYk/cOIsAcx+iH1euwfrt7Bb/ywDEtyQStwRHw2s+KcewRewaaEerImLSu0CHxM6N0o22FDWeVnTwmTQvsIeiF9t/lB6P7ewqSb3FCwuFBCR7g1xiEFFjv7pQqdp+saR9KQVADfPVeNaoD5OHYi9ZvC4OcyOGlgwNru1/p+06zRW+xgnX0/zxjVRsMY9ZbRhZF1Q4P/i+ExSDPU7UyNL6j2irZnlweyuzmhOC5OBXFFYpQf5kxpudbcSqysiKGBAR/jRqWikqeLwfzYB7uKljfPFfPuDg+Am8fHSP0c9B6fdO1kRq3mmwJOkj5G4BL0pPRLt8eop2J5hYyLfO7uPiIurQcjNxWUkcnn/hKQ76aBEiv+TA2gKwNaPjGPwRPn1Zizft57PVvEpPA+8ueNpDNPVq60zKpnrdO7xUpkiYBX1vJqG15uM7916+wKt6IicxZ27p3xFmMOvUBHr5cReB29CBTsSspQ1l0IwRuy+O0lfwDAnU0yiUzkbwAAAABJRU5ErkJggg=="
          alt="" style="width:10%;height:10%;">
        <div style="flex:1;">
          <div style="line-height:1.5rem;font-size:1.2rem;font-weight:bold;color:#21477A;">데이트</div>
          <div style="font-size:.8rem;"> 등록 여성과 만나신 후에는 두 분이 자유롭게 교제하시면 됩니다. 이후의 관계는 두 분이 규칙을 정해서 즐기시길 바랍니다.</div>
        </div>
      </div>
    </div>
    <div style="padding:12px;"><h2 style="background-color:#e62978;text-align:center;line-height:2;"><strong><span
        style="font-size:20px;"><span style="color:#ffffff;"> 고객의 목소리 </span></span></strong></h2></div>
    <div style="padding: 12px;">

      <swiper class="van-swipe"   :options="bannerSwiperOption">
        <swiper-slide v-for="(v,key) in list1" :key="key">


          <div style="padding: 8px 12px; border: 3px solid rgb(230, 41, 120); border-radius: 12px;">
            <div style="display: flex;">
              <img :src="v.url" alt=""
                   style="width: 40%; border-radius: 12px;">
              <div style="flex: 1 1 0%; padding-left: 12px;">
                <div style="line-height: 1.5rem; font-weight: bold;">{{ v.name1 }}</div>
                <div style="line-height: 2rem; font-weight: bold;">{{ v.name2 }}</div>
                <div style="line-height: 1.2rem; color: rgb(230, 41, 120); font-weight: bold;">
                  {{ v.name3 }}
                </div>
              </div>
            </div>
            <div style="padding: 8px;">
              {{ v.name4 }}
            </div>
          </div>
        </swiper-slide>
      </swiper>

    </div>
    <div><img src="img/foot.png" alt="" style="width: 100%;"></div>
    <div style="height: 20px;"></div>
  </div>
</template>

<script>
export default {
  data() {
    return {

      list1:[
          {
            name1: "51세 남성",
            name2: "회사 오너",
            name3: "처음 만난 여자분인데 취향이 너무 맞더라고요 진짜 대박",
            name4: "매일 바빠서 사람들이랑 친해질 기회도 없고 해서 이렇게 소셜 사이트 들어오게 된 건데… 첫만남부터 여자분이 너무 마음도 맞고 스마트한 분이시라 오랜 친구처럼 너무 친근했어요 완전 운명의 상대! ",
            url: "img/k1.jpg"
          },
          {
            name1: "42세 남성",
            name2: "변호사",
            name3: "프라이버시 보호가 확실히 되니까 마음 놓고 즐길 수 있었습니다",
            name4: "일 때문에 프라이버시를 엄청 중요하게 생각해서 이런 사이트 가입하는 거 조금 조심스러웠었는데 사이트 구조도 그렇고 세세하게 다 알아서 에스코트 해주시니까 너무 좋았어요 이상형이랑 즐거운 시간 보내고 있습니다",
            url: "img/k2.jpg"
          },
          {
            name1: "38세 남성",
            name2: "광고대행사 근무",
            name3: "매번 색다른 재미를 느낄 수 있단게 큰 매력이죠",
            name4: "몇번 이용해봤는데 여러 타입 여자분들 진짜 매력 어마어마하신 분들 ㅋㅋㅋᩚ 이렇게 만나는게 좋았어요 일이 힘든데 이런 부분이 즐겁다보니 일 할 맛도 납니다 글구 해외에서 살다오신 분이랑 얘기 나눠봤는데 진짜 지렸습니다 좋은 시간 보냈어요 ㅋㅋᩚ",
            url: "img/k3.jpg"
          },
          {
            name1: "55세 남성",
            name2: "건설사 임원",
            name3: "따분한 내 삶의 새로운 활력소가 생긴 느낌입니다. 매일매일이 보람찹니다.",
            name4: "일만 하면서 살았는데 이렇게 우리 플랫폼 여성분들 알아가면서 뭔가 색다른 하루하루를 보내고 있습니다. 다른 업종 여자분이랑 얘기를 하는게 특히나 좋습니다. 시야도 넓어지고 삶이 더 다채로워졌습니다.",
            url: "img/k4.jpg"
          },
          {
            name1: "46세 남성",
            name2: "패션브랜드 대표",
            name3: "와 기대했던 것보다 더 감동입니다 엄청 알찬 시간 보냈어요",
            name4: "평소엔 만날 수 없는 여자분들을 이렇게 만날 수 있단게 여기 매력인 거 같습니다 비록 첫번째 상대분이랑은 가치관이 맞지 않아 별 느낌 없었지만 지금 두번째 여자분은 너무 이상형에 가까운 분이라 해외여행도 계획중에 있습니다 직원분들 일도 빠릿빠릿 잘하시고 여자분들 퀄리티도 좋고 완전 만족입니다",
            url: "img/k5.jpg"
          },
          {
            name1: "38세 여성",
            name2: "회사원",
            name3: "생각보다 훨씬 좋은 곳인듯 ㅎㅎ",
            name4: "첨엔 좀 불안한 감도 없지 않아 있었는데 직원분들도 넘 친절하구 그래서 완전 안심하구 사용중 헷 글구! 남자분들도 다 완전 젠틀하시구 ㅠㅠ 너무 조아따 이렇게 스트레스 한번씩 푸니까 가치관두 뭔가 완성돼가는 거 같고 매일매일 기대되고 그런 느낌",
            url: "img/k6.jpg"
          },
          {
            name1: "32세 여성",
            name2: "프리랜서",
            name3: "새로운 분들이랑 만나는게 새로운 삶의 활력소가 됐습니다",
            name4: "남자분이랑 평소 마주치지 힘든 업종에서 일하는데 지금 이렇게 편하게 얘기하고 하는게 큰 메리트로 느껴집니다 다들 젠틀하시고 매너 있으셔서 남자분들 대하는 것도 더 적응해가고 있는 중입니다 만족스럽게 이용 중입니다",
            url: "img/k7.jpg"
          },
          {
            name1: "28세 여성",
            name2: "종업원",
            name3: "마음의 힐링이 찾아옵니다",
            name4: "낯 가리는 성격인데 여기 남자분들은 다 착하셔서 편하게 행동할 수 있는 거 같아요~ 매번 대화 재밌게 하고 나면 다음 만남이 기대가 됩니다 ㅋㅋㅋㅋ 여기서 좋은 분 만나 짜릿하게 즐기고 싶네용",
            url: "img/k8.jpg"
          },
          {
            name1: "49세 여성",
            name2: "서비스업종",
            name3: "평생 못잊을 즐거운 경험 했습니당 넘 좋아용",
            name4: "큰 기대는 안했는데 너무 좋은 분을 만나서 하핳 앞으로 취미생활도 같이 즐기고 재밌게 사귀고 싶어요~^^ 잔잔했던 마음에 파도가 치네요 감사합니다◡̈",
            url: "img/k9.jpg"
          }
      ],

        list:[
            {
              address: "서울",
              title: "정통 청순 미녀",
              content: "모델 같은 몸매",
              url: "img/hy1.jpg"
            },
            {
              address: "대구",
              title: "웃음이 매력적인 귀여운 여자",
              content: "무한한 매력",
              url: "img/hy2.jpg"
            },

            {
              address: "부산",
              title: "옷 너머로도 육감적인 몸매",
              content: "글래머한 곡선은 마치 라잌 모델",
              url: "img/hy3.jpg"
            },
            {
              address: "대전",
              title: "레이싱걸보다 핫한 다리",
              content: "",
              url: "img/hy4.jpg"
            },
            {
              address: "인천",
              title: "시크한 여자",
              content: "겉으론 차가워보여도 마음은 따뜻한 사람 슬쩍 짓는 웃음이 매력적",
              url: "img/hy5.jpg"
            },
            {
              address: "울산",
              title: "맛있는 걸 함께 나눌 사람 원해요",
              content: "",
              url: "img/hy6.jpg"
            }
        ],
        bannerSwiperOption: {
          grabCursor: true,
          centeredSlides: true,
          slidesPerView: 'auto',
          speed: 800,
          autoplay: true,
          coverflowEffect: {
            rotate: 50,
            stretch: 10,
            depth: 100,
            modifier: 1,
            slideShadows: true
          }
        }
    }
  }
}
</script>

<style scoped>

</style>
